// Types
import { GetStores_stores_entities } from 'api/store/types/GetStores';
import { GetAllHomePageData_getHomePageData_stores } from 'api/homePage/types/GetAllHomePageData';
import { ProductTypesType } from 'api/graphql-global-types';
// Constants
import { ATHLETES } from 'constants/routes';
// Helpers
import { formatSportsForDisplay } from 'helpers/sports';
// Ui
import ProductCard from 'ui3/Card/ProductCard';
// Styles
import styles from './StoreListItem.module.scss';

type StoreListItemProps = {
  store: GetStores_stores_entities | GetAllHomePageData_getHomePageData_stores;
  storeImageLazyLoading?: boolean;
  type?: 'list' | 'carousel';
};

const StoreListItem = ({
  store,
  storeImageLazyLoading,
  type,
}: StoreListItemProps) => {
  const { slug, storeDetails, sports } = store;
  const sportsList = sports?.map((item) => item.name);
  const displaySports = formatSportsForDisplay(sportsList);

  return (
    <ProductCard
      type={ProductTypesType.Experience}
      title={storeDetails?.storeName || storeDetails?.storeTitle || ''}
      linkUrl={slug ? `/${slug}` : ATHLETES}
      imageUrl={storeDetails?.avatarURL || ''}
      priorityImageLoading={!storeImageLazyLoading}
      {...(type === 'list' && {
        customLabels: displaySports,
        customLabelsPosition: 'top',
        customLabelsVariant: 'primary',
      })}
      descriptionClassName={styles.description}
      hideCategory
    />
  );
};

export default StoreListItem;
